
class Data {
  
  Login = {
    ApxToken: null,
    ErrorCallback: null,
    ShowLoginButton: null,
    GetTokenCallback: null,
    IsCodePresent: false,
    FirstName: "",
    LastName: "",
    Email: "",
    Secret: "",
    Modules:[],
  }
  
  Main = {
    ReportChangeCallback: null,
    OpenMainView: null
  }

  Finance = {
    ShowProgress: null
  }

  Service = {
    GetReport: null,
    GetReportCallback: null,
    ErrorCallback: null,
    SuccessCallback: null,
    CreateFreeTrial: null,
    FreeTrialCallback: null,
    GetAPXTokenForCustomer: null,
    AddAccountManagementHistoryItem: null,
    GetAccountManagementHistoryList: null,
    GetAccountManagementHistoryListCallback: null,
    SendDocumentUploadURL: null,
    SendDocumentUploadURLCallback: null,
    ReTier: null,
    ReTierCallback: null,
    FirmNameCallback: null,
    AOStatus: null,
    SendManageAccountURL:null,
    GetAccountDetails:null
  }

  AccountManagement = {
    SetCount: null
  }

  APX = {
    APXModuleCallback: null,
    AccountManagementCallback:null
  }
}
 
 export default Data;